'use strict';

require('@firebase/database-compat');

//# sourceMappingURL=index.cjs.js.map
